import type { Question } from './types';

// Consider promote to a shared utils
export function updateImageTags(content: string, urlObject: Record<string, string>) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  const images = doc.getElementsByTagName('img');

  for (const img of Array.from(images)) {
    const contentAttr = img.getAttribute('content');
    if (contentAttr && urlObject[contentAttr]) {
      img.setAttribute('src', urlObject[contentAttr]);
    }
  }

  return doc.body.innerHTML;
}

// Consider promote to a shared utils
function extractImagesFileNames(content: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  const images = doc.getElementsByTagName('img');

  const filenames: string[] = [];

  for (const img of Array.from(images)) {
    const contentAttr = img.getAttribute('content');
    if (contentAttr) {
      filenames.push(contentAttr);
    }
  }

  return [...new Set(filenames)]; // Remove duplicates
}

export function getQuestionFileNames(question: Question) {
  const questionFileNames: string[] = [];
  const questionGroupFileNames: string[] = [];

  questionFileNames.push(...extractImagesFileNames(question.details));
  questionFileNames.push(...extractImagesFileNames(question.solution?.value ?? ''));
  questionFileNames.push(...extractImagesFileNames(question.metadata?.reference ?? ''));

  for (const id in question.metadata.choices) {
    const choiceLabel = question.metadata.choices[id].label;
    questionFileNames.push(...extractImagesFileNames(choiceLabel));
  }

  return {
    questionFileNames,
    questionGroupFileNames,
  };
}

export function mapImageContentForQuestion(
  question: Question,
  questionAssetMap: Record<string, string>,
) {
  return {
    ...question,
    details: updateImageTags(question.details, questionAssetMap ?? {}),
    solution: {
      ...question.solution,
      value: updateImageTags(question.solution?.value ?? '', questionAssetMap ?? {}),
    },
    questionGroup: question.questionGroup
      ? {
          ...question.questionGroup,
        }
      : null,
    metadata: {
      ...question.metadata,
      reference: updateImageTags(question.metadata.reference ?? '', questionAssetMap ?? {}),
      choices: question.metadata.choices.map((choice) => ({
        ...choice,
        label: updateImageTags(choice.label, questionAssetMap ?? {}),
      })),
    },
  } as Question;
}
